<div class="my-overlay" *ngIf="overlay">
  <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
  <p class="my-overlay__message" *ngIf="showOverlayMessage">{{overlayMessage}}</p>
</div>
<app-header id="header-fixed" class="topnavbar-wrapper" *ngIf="showHeader()"></app-header>
<!--<app-whatsup></app-whatsup>-->
<main [@fadeAnimation]="o.isActivated ? o.activatedRoute : ''" [ngStyle]="{'margin-top': (showHeader()) ? '' : '0'}">
  <router-outlet #o="outlet"></router-outlet>
</main>
